module.exports = __webpack_public_path__ + "media/news/leipzig-news-01-20078c02.webp";